import script from "./MessageTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageTable.vue?vue&type=script&setup=true&lang=ts"

import "./MessageTable.vue?vue&type=style&index=0&id=503c7f98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503c7f98"]])

export default __exports__